import Search from '@mui/icons-material/Search';
import { Chip, InputAdornment, Stack, TextField } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { TasksPermission } from 'gql/index';
import type { ProjectTasksOwnershipFilterKey, ProjectTasksTimelineFilterKey } from '../hooks/useProjectTasksFilters';

type ProjectTasksFiltersProps = {
  search: string;
  onSearchChange: (value: string) => void;
  ownershipFilter: ProjectTasksOwnershipFilterKey;
  onOwnershipFilterChange: (value: ProjectTasksOwnershipFilterKey) => void;
  timelineFilter: ProjectTasksTimelineFilterKey;
  onTimelineFilterChange: (value: ProjectTasksTimelineFilterKey) => void;
  tasksPermission?: TasksPermission | null;
};

export const ProjectTasksFilters: React.FC<ProjectTasksFiltersProps> = ({
  search,
  onSearchChange,
  ownershipFilter,
  onOwnershipFilterChange,
  timelineFilter,
  onTimelineFilterChange,
  tasksPermission
}) => {
  const { formatMessage } = useIntl();
  const allTasksLabelId = tasksPermission === TasksPermission.LimitedAccess ? 'Shared with me' : 'All tasks';

  return (
    <Stack gap={1}>
      <TextField
        value={search}
        onChange={e => onSearchChange(e.target.value)}
        placeholder={formatMessage({ id: 'Search tasks' })}
        size='small'
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <Search fontSize='small' />
              </InputAdornment>
            )
          }
        }}
      />

      <Stack direction='row' gap={1} flexWrap='wrap'>
        <Chip
          label={formatMessage({ id: 'My tasks' })}
          color={ownershipFilter === 'mine' ? 'primary' : 'default'}
          onClick={() => onOwnershipFilterChange('mine')}
          variant={ownershipFilter === 'mine' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: allTasksLabelId })}
          color={ownershipFilter === 'all' ? 'primary' : 'default'}
          onClick={() => onOwnershipFilterChange('all')}
          variant={ownershipFilter === 'all' ? 'filled' : 'outlined'}
        />
      </Stack>

      <Stack direction='row' gap={1} flexWrap='wrap'>
        <Chip
          label={formatMessage({ id: 'Incomplete' })}
          color={timelineFilter === 'incomplete' ? 'primary' : 'default'}
          onClick={() => onTimelineFilterChange('incomplete')}
          variant={timelineFilter === 'incomplete' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: 'Today' })}
          color={timelineFilter === 'today' ? 'primary' : 'default'}
          onClick={() => onTimelineFilterChange('today')}
          variant={timelineFilter === 'today' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: 'Upcoming' })}
          color={timelineFilter === 'upcoming' ? 'primary' : 'default'}
          onClick={() => onTimelineFilterChange('upcoming')}
          variant={timelineFilter === 'upcoming' ? 'filled' : 'outlined'}
        />
        <Chip
          label={formatMessage({ id: 'Completed' })}
          color={timelineFilter === 'completed' ? 'primary' : 'default'}
          onClick={() => onTimelineFilterChange('completed')}
          variant={timelineFilter === 'completed' ? 'filled' : 'outlined'}
        />
      </Stack>
    </Stack>
  );
};
